<template>
    <div class="withdrawal-container">
        <div class="section-title">
            {{ $t('withdrawal') | capitalize }}
        </div>
        <div class="content">
            <router-link
                :to="{ name: routeNames.withdrawal }"
                class="btn btn__secondary btn__icon--left"
                tag="button"
            >
                <i class="icon--md icon-withdrawal mr-2" />
                {{ $t('retract funds') | capitalize }}
            </router-link>
        </div>
    </div>
</template>

<script>
    import { routeNames } from '@app/router';

    export default {
        props: {
            amount: {
                type: Number,
                required: true,
            }
        },
        created() {
            this.routeNames = routeNames;
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/userProfile/components/Withdrawal.vue